import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface UsageStatisticsCopy {
  copyType: SystemCode
  counter: number
  counterNumber: number
}

export function UsageStatisticsCopyFromJSON(json: any): UsageStatisticsCopy {
  return {
    copyType: exists(json, 'copy_type')
      ? SystemCodeFromJSON(json.copy_type)
      : defaultSystemCode(),
    counter: exists(json, 'counter') ? json.counter : 0,
    counterNumber: exists(json, 'counter_number') ? json.counter_number : 0
  }
}
